import { Box } from '@mantine/core';
import Drawer from '../drawer/Drawer.tsx';
import SearchableServiceList from './SearchableServiceList.tsx';
import { ServiceListProps } from './ServiceList.tsx';

interface ServiceSelectorProps extends ServiceListProps {
  opened: boolean;
  onClose: () => void;
  jurisdiction?: string;
}

export default function ServiceSelector({
  opened,
  onClose,
  onSelect,
  parentServiceId,
  jurisdiction,
  exclude,
  itemRenderer,
  currency,
  isAdditionalService,
}: ServiceSelectorProps) {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title="Select Services"
      padding="md"
      className="no-block-deselect"
      styles={{ content: { minWidth: 960 } }}
    >
      <Box p="xs">
        <SearchableServiceList
          onSelect={onSelect}
          itemRenderer={itemRenderer}
          parentServiceId={parentServiceId}
          jurisdiction={jurisdiction}
          currency={currency}
          exclude={exclude}
          isAdditionalService={isAdditionalService}
        />
      </Box>
    </Drawer>
  );
}
